import React from 'react';
import { RemoveIconBig } from 'components/common/icons';
import { Modal, Button, Row, Col, Typography } from 'components';

const { Title, Text } = Typography;

interface DeleteBrandModalProps {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export const DeleteBrandModal: React.FC<DeleteBrandModalProps> = ({ open, onOk, onCancel, loading }) => (
  <Modal
    open={open}
    onOk={onOk}
    onCancel={onCancel}
    closable={false}
    width={360}
    centered
    footer={() => (
      <Row wrap={false} className={'gap-8'} style={{ marginTop: '24px' }}>
        <Button block size={'large'} onClick={onCancel}>
          Cancel
        </Button>
        <Button loading={loading} block size={'large'} type="primary" onClick={onOk}>
          Remove
        </Button>
      </Row>
    )}
  >
    <Row align={'middle'} gutter={[0, 12]} justify={'center'}>
      <RemoveIconBig />
      <Col span={24}>
        <Title style={{ color: '#222530', textAlign: 'center', margin: 0, padding: 0 }} level={3}>
          Remove Brand
        </Title>
      </Col>
      <Text className={'center'}>Are you sure you want to remove this brand from the lead?</Text>
    </Row>
  </Modal>
);
